import React, { useCallback, useEffect, useState } from "react";
import PageHeader from "../../../shared/PageHeader";
import Button from "../../../components/form/Button";
import Input from "../../../components/form/Input";
import SingleImageUpload from "../../../components/form/SingleImageUpload";
import { formValidate } from "../../../helpers/formValidate";
import useForm from "../../../hooks/useForm";
import { Validation } from "../../../helpers/Validation";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { addUser, userDetails } from "../../../services/userService";
import { setTitle } from "../../../helpers/MetaTag";

const UserAddEdit = () => {
  setTitle("Service Flows");
  const { id } = useParams();
  const validation = {
    name: { required: true, message: "Please enter your name !!!" },
    email: { required: true, message: "Please enter your email !!!" },
    companyName: { required: true, message: "Please enter company name !!!" },
    vatNumber: { required: true, message: "Please enter vat number !!!" },
    bankName: { required: true, message: "Please enter bank name !!!" },
    accountNumber: {
      required: true,
      message: "Please enter account number!!!",
    },
    routingNumber: {
      required: true,
      message: "Please enter routing number!!!",
    },
    bankAddress: {
      required: true,
      message: "Please enter bank address!!!",
    },
    SWIFTCode: {
      required: true,
      message: "Please enter SWIFT code!!!",
    },
    password: {
      required: id ? false : true,
      message: "Please enter your password !!!",
    },
  };
  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({}, validation);
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [companyImage, setCompanyImage] = useState();
  const [detailsData, setDetailsData] = useState({ loading: false, data: {} });

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8) {
      errors.push("Password must be at least 8 characters long.");
    }
    if (!/(?=.*\d)/.test(password)) {
      errors.push("Password must contain at least one digit.");
    }
    if (!/(?=.*[a-z])/.test(password)) {
      errors.push("Password must contain at least one lowercase letter.");
    }
    if (!/(?=.*[A-Z])/.test(password)) {
      errors.push("Password must contain at least one uppercase letter.");
    }
    if (!/(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])/.test(password)) {
      errors.push(
        "Password must contain at least one special character (!@#$%^&*()_+-=[]{};':\"\\|,.<>/?)."
      );
    }

    return errors;
  };

  console.log(id, "id");
  const getDetails = useCallback(() => {
    if (id) {
      setDetailsData({ loading: true, data: {} });
      userDetails({ id }).then((res) => {
        if (res?.status === 200) {
          setDetailsData({ loading: true, data: res?.docs });
          console.log(res, "resss");
          setFieldsValue({
            name: res?.docs?.name || "",
            email: res?.docs?.email || "",
            companyName: res?.docs?.companyName || "",
            vatNumber: res?.docs?.vatNumber || "",
            bankName: res?.docs?.bankName || "",
            accountNumber: res?.docs?.accountNumber || "",
            routingNumber: res?.docs?.routingNumber || "",
            bankAddress: res?.docs?.bankAddress || "",
            SWIFTCode: res?.docs?.SWIFTCode || "",
          });
          setImageUrl(res?.docs?.imageUrl);
          setCompanyImage(res?.docs?.companyImageUrl);
        }
      });
    }
  }, [id]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  const onSubmit = async (values) => {
    setLoaded(true);
    try {
      if (!Validation("name", values.name)) {
        toast.error("Name cannot be empty or contain only spaces.");
        setLoaded(false);
        return;
      }
      if (!Validation("email", values.email)) {
        toast.error("Invalid email format. Please enter a valid email.");
        setLoaded(false);
        return;
      }
      if (values.password) {
        const passwordErrors = validatePassword(values.password);
        if (passwordErrors.length > 0) {
          toast.error(passwordErrors.join(" "));
          setLoaded(false);
          return;
        }
      }
      if (
        values.password &&
        !Validation("confirmPassword", values.confirmpassword, values.password)
      ) {
        console.log("khoioohoh");
        toast.error("Confirm password and password doesn`t match");
        setLoaded(false);
        return;
      }
      const res = await addUser({
        id: id,
        image: imageUrl,
        companyImage: companyImage,
        name: values?.name,
        email: values?.email,
        companyName: values?.companyName,
        vatNumber: values?.vatNumber,
        bankName: values?.bankName,
        accountNumber: values?.accountNumber,
        routingNumber: values?.routingNumber,
        bankAddress: values?.bankAddress,
        SWIFTCode: values?.SWIFTCode,
        roleCode: "user",
        password: values?.password,
        password_confirmation: values?.confirmpassword,
      });

      if (res?.data?.status === 200 || res?.data?.status === 201) {
        navigate("/admin/user-list");
        toast.info(res?.data?.message);
      } else {
        toast.info(
          res?.data?.message || res?.data?.errors || "Something went wrong"
        );
      }

      setLoaded(false);
    } catch (err) {
      setLoaded(false);
      // console.error(err);
      toast.error("Somthing went wrong !!!");
    }
  };

  return (
    <div>
      <form onSubmit={(event) => handleSubmit(event, onSubmit)}>
        <PageHeader
          title={detailsData?.data?.id ? "Edit User" : "Add New User"}
          headerActions={() => (
            <div className="flex items-center space-x-3">
              <Button
                buttonHasLink={true}
                buttonLink={"/admin/user-list"}
                buttonType={"button"}
                buttonIcon={"fa-regular fa-xmark"}
                buttonIconPosition={"left"}
                buttonLabel={"Cancel"}
                buttonClasses={"!bg-white !text-primary"}
              />
              <Button
                buttonHasLink={false}
                buttonType={"submit"}
                buttonIcon={"fa-light fa-floppy-disk"}
                buttonIconPosition={"left"}
                buttonClasses={"!bg-primary !text-org-silver"}
                buttonLabel={"Save"}
                isDisable={loaded}
              />
            </div>
          )}
        />
        <div className="py-2 px-6">
          <div className="w-full bg-white rounded-md shadow  py-5 px-4">
            <div className="grid grid-cols-4 gap-4 divide-x divide-slate-200">
              <div className="col-span-3">
                <div className="space-y-3">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-regular fa-user"}
                        inputGroupPosition={"left"}
                        label={"Name"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.name}
                        inputName={"name"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Name"}
                        {...formValidate(errors, "name")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-solid fa-envelope"}
                        inputGroupPosition={"left"}
                        label={"Email"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.email}
                        inputName={"email"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Email"}
                        {...formValidate(errors, "email")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-solid fa-building"}
                        inputGroupPosition={"left"}
                        label={"Company Name"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.companyName}
                        inputName={"companyName"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Company Name"}
                        {...formValidate(errors, "companyName")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-regular fa-circle-n"}
                        inputGroupPosition={"left"}
                        label={"Vat Number"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.vatNumber}
                        inputName={"vatNumber"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Vat Number"}
                        {...formValidate(errors, "vatNumber")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-solid fa-building-columns"}
                        inputGroupPosition={"left"}
                        label={"Bank Name"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.bankName}
                        inputName={"bankName"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Bank Name"}
                        {...formValidate(errors, "bankName")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-solid fa-piggy-bank"}
                        inputGroupPosition={"left"}
                        label={"Account Number"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.accountNumber}
                        inputName={"accountNumber"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Account Number"}
                        {...formValidate(errors, "accountNumber")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-regular fa-route-interstate"}
                        inputGroupPosition={"left"}
                        label={"Routing Number"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.routingNumber}
                        inputName={"routingNumber"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Routing Number"}
                        {...formValidate(errors, "routingNumber")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-solid fa-location-dot"}
                        inputGroupPosition={"left"}
                        label={"Bank Address"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.bankAddress}
                        inputName={"bankAddress"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter Bank Address"}
                        {...formValidate(errors, "bankAddress")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-brands fa-swift"}
                        inputGroupPosition={"left"}
                        label={"SWIFT Code"}
                        labelClasses={"!text-base"}
                        inputType={"text"}
                        value={values.SWIFTCode}
                        inputName={"SWIFTCode"}
                        onChange={handleChange}
                        inputPlaceholder={"Enter SWIFT Code"}
                        {...formValidate(errors, "SWIFTCode")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-solid fa-key"}
                        inputGroupPosition={"left"}
                        label={"Password"}
                        inputPlaceholder={"Enter  Password"}
                        labelClasses={"!text-base"}
                        inputType={"password"}
                        value={values.password}
                        inputName={"password"}
                        onChange={handleChange}
                        {...formValidate(errors, "password")}
                      />
                    </div>
                    <div className="relative col-span-6">
                      <Input
                        isInputGroup={true}
                        inputGroupIcon={"fa-solid fa-key"}
                        inputGroupPosition={"left"}
                        label={"Confirm Password"}
                        inputPlaceholder={"Enter Confirm Password"}
                        labelClasses={"!text-base"}
                        inputType={"password"}
                        value={values.confirmpassword}
                        inputName={"confirmpassword"}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-1 pl-4 gap-3">
                <div className="relative">
                  <SingleImageUpload
                    label={"User Image"}
                    size={"lg"}
                    image={imageUrl}
                    setImage={setImageUrl}
                    accept={["jpg", "png", "jpeg"]}
                  />
                </div>
                <div className="relative">
                  <SingleImageUpload
                    label={"Company Image"}
                    size={"lg"}
                    image={companyImage}
                    setImage={setCompanyImage}
                    accept={["jpg", "png", "jpeg"]}
                  />
                </div>
              </div>
            </div>
            <div className="mt-8 pt-4 border-t border-slate-200">
              <div className="flex items-center space-x-3">
                <Button
                  buttonHasLink={true}
                  buttonLink={"/admin/user-list"}
                  buttonType={"button"}
                  buttonIcon={"fa-regular fa-xmark"}
                  buttonIconPosition={"left"}
                  buttonLabel={"Cancel"}
                  buttonClasses={
                    "!bg-white !text-primary !border-primary !border-2"
                  }
                />
                <Button
                  buttonHasLink={false}
                  buttonType={"submit"}
                  buttonIcon={"fa-light fa-floppy-disk"}
                  buttonIconPosition={"left"}
                  buttonClasses={"!bg-primary !text-org-silver"}
                  buttonLabel={"Save"}
                  isDisable={loaded}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserAddEdit;
